export type TriggerType = 'ScheduleTrigger' | 'BlobEventsTrigger' | 'CustomEventsTrigger' | 'RerunTumblingWindowTrigger' | 'ChainingTrigger' | 'TumblingWindowTrigger' | 'Unknown';

export enum SubscriptionStatus {
    Enabled = 'Enabled',
    Provisioning = 'Provisioning',
    Deprovisioning = 'Deprovisioning',
    Disabled = 'Disabled',
    Unknown = 'Unknown'
}

export interface IEventTriggerStatus {
    triggerName: string;
    status: SubscriptionStatus;
}
